/*
 * @Date: 2019-06-25 17:02:48
 * @Last Modified time: 2020-09-11 17:50:27
 * @Name UEM 提供的能力封装，统一位置封装能力，便于后期维护
 */
export default {

    /**
     * @param {*} pageCode 在UEM中登记注册的页面编码
     * @name 页面埋码方法
     */
    trackPageView(pageCode, params) {
        window.hwa('trackPageView', pageCode, params)
    },

    /**
     * @param {*} pageCode 在UEM中登记注册的页面编码
     * @name 事件埋码方法
     */
    trackStructEvent(label, value, url, data) {
        let params = {
            label: label,
            value: value,
            url: url,
            data: data
        }
        window.hwa('trackStructEvent', params)
    }
}
